import { IconButton, Stack, TableCell, TableRow } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../textField';

type Props = {
  customEvent?: any;
  errror?: string;
  onAdd: (customEvent: any) => void;
  onCancelAdd: () => void;
};

const EmittedCustomEvent = ({ customEvent, onAdd, onCancelAdd }: Props) => {
  const { t } = useTranslation();

  const [eventName, setEventName] = useState<any>(customEvent?.eventName);
  const [eventLabel, setEventLabel] = useState<string>(customEvent?.eventLabel);

  const [changed, setChanged] = useState(false);

  const [errors, setErrors] = useState<any>({});

  const onEventNameChange = (eventName: string) => {
    setEventName(eventName);
    setChanged(true);
  };

  const onEventLabelChange = (eventLabel: string) => {
    setEventLabel(eventLabel);
    setChanged(true);
  };
  const cancelAdd = () => {
    onCancelAdd();
  };

  const addCustomEvent = () => {
    let hasError = false;
    const errors: any = {};
    if (!eventName) {
      errors.eventName = t('common.errors.requiredField');
      hasError = true;
    }

    if (!eventLabel) {
      errors.eventLabel = t('common.errors.requiredField');
      hasError = true;
    }

    setErrors(errors);
    if (!hasError) {
      onAdd({
        eventName,
        eventLabel,
      });
    }
  };

  return (
    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell align="right">
        <TextField
          required
          value={eventName}
          autoFocus
          onChange={onEventNameChange}
          error={errors.eventName}
          fullWidth={true}
        />
      </TableCell>
      <TableCell align="right">
        <TextField required value={eventLabel} autoFocus onChange={onEventLabelChange} error={errors.eventLabel} />
      </TableCell>

      <TableCell align="left">
        <Stack direction={'row'} alignItems={'center'}>
          <IconButton size="small" onClick={addCustomEvent} color="primary" disabled={!changed}>
            <CheckIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => cancelAdd()}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export default EmittedCustomEvent;
